export default __webpack_public_path__ + "static/media/profile.e7bfc150.svg";